export default __webpack_public_path__ + "static/media/cft-project@2x.c2411f8c.jpg";